define('jquery.1508.mobileNav',['jquery'],
	function ($) {
		var methods = {
			init: function (options) {
				this.each(function () {
					var defaults, settings, $this, elemHeight;
					$this = $(this);
					settings = $this.data('mobileNav');
					if (typeof (settings) === 'undefined') {
						defaults = {
							container: '.selector',
							button: '.button'
						};

						settings = $.extend({}, defaults, options);
						$this.data('mobileNav', settings);
					} else {
						settings = $.extend({}, settings, options);
					}

					elemHeight = $this.outerHeight(true);

					$(window).resize(function () {
						if (!$(settings.container).hasClass('expanded')){
							$this.css('height', 'auto');
							elemHeight = $this.outerHeight(true);
						}

						var newHeight = $this.outerHeight(true);
						if (newHeight > elemHeight) {
							elemHeight = newHeight;
						}


						if (Modernizr.mq('only screen and (max-width: 768px)')) {
							$('.bottom-section').css({ 'position': 'relative' });
						} else if ($('body').outerHeight(true) >= 818) {
							$(settings.container).removeAttr('style');
							$('body').css({ 'position': 'relative' });
							$('.bottom-section').css({ 'position': 'absolute' });
							$('.main').removeClass('expanded');
							$('.fp-sector-container p').show();	
							$('.frontpage-sectors').css('margin-top', '15px');
						}
						else {
							if ($('body').outerWidth(true) <= 900){
								$('.fp-sector-container p').hide();
								$('.frontpage-sectors').css('margin-top', '-15px');
							}
							else{
								$('.fp-sector-container p').show();	
								$('.frontpage-sectors').css('margin-top', '-15px');
							}
							$(settings.container).removeAttr('style');
							$('.bottom-section').css({ 'position': 'relative' });
							$('.main').removeClass('expanded');
						}
					});

					$(settings.button).on('click', function (e) {
						if ($(settings.container).hasClass('expanded')) {
							$(settings.container).removeClass('expanded').css(Modernizr.prefixed('transform'), 'translate3d(0,0,0)');
							$this.animate({
								height: '0px'
							}, (500), function() {
								$this.css({ 'visibility': 'hidden', 'height': 'auto' });
								// $('.global-search').blur();
							});
						} else {
                            elemHeight = $this.outerHeight(true);
							$(settings.container).addClass('expanded').css(Modernizr.prefixed('transform'), 'translate3d(0,auto,0)');
							$this.css({'height': 'auto', 'visibility': 'visible', 'overflow': 'hidden'}).animate({
								height: 'auto'
							}, (500), function () {
								// $('.global-search').focus();
							});
                        }
					});
				});
			}
		};
		$.fn.mobileNav = function (method) {
			if (methods[method]) {
				return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
			} else if (typeof method === 'object' || !method) {
				return methods.init.apply(this, arguments);
			} else {
				$.error('Method ' + method + ' does not exist in jQuery.mobileNav');
			}
		};
	});

